import { render, staticRenderFns } from "./FixTool.vue?vue&type=template&id=bcb64ee8&scoped=true&"
import script from "./FixTool.vue?vue&type=script&lang=js&"
export * from "./FixTool.vue?vue&type=script&lang=js&"
import style0 from "./FixTool.vue?vue&type=style&index=0&id=bcb64ee8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb64ee8",
  null
  
)

export default component.exports